export const CONFIGURATION_SELECT = 'CONFIGURATION_SELECT';
export const CONFIGURATION_DESELECT = 'CONFIGURATION_DESELECT';
export const CONFIGURATION_CREATE_START = 'CONFIGURATION_CREATE_START';
export const CONFIGURATION_CREATE_STOP = 'CONFIGURATION_CREATE_STOP';
export const UNLOAD = 'paycon/UNLOAD';
